import _Link from "@arco-design/web-react/es/Link";
import _Form from "@arco-design/web-react/es/Form";
import _Cascader from "@arco-design/web-react/es/Cascader";
import _useRequest from "@byted/hooks/es/useRequest";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { listSpaces, checkSpacePermission, quickCreateSpace, listUserSpaces } from '@src/utils/api/space';
import useLocale from '@src/hooks/useLocale';
function SelectSpace(props) {
  var _this = this;
  var isFirst = useRef(true);
  var _a = _useRequest(function (keyword) {
      return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, listSpaces({
                limit: 1000,
                keyword: keyword
              })];
            case 1:
              data = _a.sent();
              return [2, (data === null || data === void 0 ? void 0 : data.list) || []];
          }
        });
      });
    }, {
      auto: true
    }),
    spaces = _a.data,
    loading = _a.loading,
    run = _a.run;
  var value = useMemo(function () {
    var _a = props.value || {},
      spaceId = _a.spaceId,
      groupId = _a.groupId;
    return spaceId && groupId ? [spaceId, groupId] : [];
  }, [props.value]);
  useEffect(function () {
    var _a;
    if (isFirst.current && spaces) {
      var _b = props.value || {},
        spaceId_1 = _b.spaceId,
        groupId = _b.groupId;
      var space = spaceId_1 ? spaces.find(function (x) {
        return x._id === spaceId_1;
      }) : null;
      if (space) {
        props.onChange({
          spaceId: spaceId_1,
          groupId: groupId || ((_a = space.groups) === null || _a === void 0 ? void 0 : _a[0]._id)
        });
      }
      isFirst.current = false;
    }
  }, [spaces]);
  return /*#__PURE__*/React.createElement(_Cascader, {
    loading: loading,
    value: value,
    showEmptyChildren: true,
    onChange: function onChange(v) {
      props.onChange({
        spaceId: v[0],
        groupId: v[1] || 0
      });
    },
    showSearch: true,
    onSearch: run,
    options: (spaces || []).map(function (x) {
      return __assign(__assign({}, x), {
        _id: x._id
      });
    }),
    fieldNames: {
      label: 'name',
      value: '_id',
      children: 'groups'
    },
    disabled: props.disabled,
    error: props.error
  });
}
var SelectSpaceFormItem = function SelectSpaceFormItem(props) {
  var _a = useLocale(undefined, props.lang),
    t = _a.t,
    isDefaultLang = _a.isDefaultLang;
  var _b = __read(useState({
      spaceId: ''
    }), 2),
    createSpace = _b[0],
    setCreateSpace = _b[1];
  var loading = _useRequest(function (keyword) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, list, data, target;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, listUserSpaces({
              limit: 1000,
              keyword: keyword
            })];
          case 1:
            _a = _b.sent().list, list = _a === void 0 ? [] : _a;
            if (!!list.length) return [3, 3];
            return [4, quickCreateSpace()];
          case 2:
            data = _b.sent();
            setCreateSpace(data);
            target = data.groups[0];
            props.form.setFieldValue('belongSpace', {
              spaceId: target.spaceId,
              groupId: target.groupId
            });
            _b.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, {
    auto: true
  }).loading;
  return /*#__PURE__*/React.createElement(_Form.Item, {
    disabled: props.disabled,
    extra: createSpace.spaceId ? /*#__PURE__*/React.createElement("span", null, "\u5DF2\u5173\u8054ArcoStudio\u9879\u76EE\uFF0C\u524D\u5F80", /*#__PURE__*/React.createElement(_Link, {
      href: "/studio/platform/themes/all?spaceId=" + createSpace.spaceId,
      target: "_blank"
    }, "ArcoStudio"), "\u4F53\u9A8C\u4E00\u7AD9\u5F0F\u8D44\u6E90\u7BA1\u7406") : /*#__PURE__*/React.createElement("span", null, "\u5173\u8054", /*#__PURE__*/React.createElement(_Link, {
      href: "/studio",
      target: "_blank"
    }, "ArcoStudio"), "\uFF0C\u9879\u76EE\u5B9E\u73B0\u8D44\u6E90\u4E92\u901A"),
    label: t['theme.create.form.space'],
    rules: [{
      required: true
    }, {
      validator: function validator(value, callback) {
        var _this = this;
        return new Promise(function (resolve) {
          return __awaiter(_this, void 0, void 0, function () {
            var groups;
            var _a, _b;
            return __generator(this, function (_c) {
              switch (_c.label) {
                case 0:
                  if (!value.spaceId) return [3, 2];
                  return [4, checkSpacePermission({
                    spaceId: value.spaceId,
                    username: (_a = window.__user__) === null || _a === void 0 ? void 0 : _a.username
                  })];
                case 1:
                  groups = _c.sent().groups;
                  if (!((_b = groups.find(function (x) {
                    return x.groupId === value.groupId;
                  })) === null || _b === void 0 ? void 0 : _b.write)) {
                    callback(isDefaultLang ? '暂无当前项目权限' : 'no permission');
                  }
                  resolve(null);
                  _c.label = 2;
                case 2:
                  callback();
                  resolve(null);
                  return [2];
              }
            });
          });
        });
      }
    }],
    hidden: props.hidden,
    field: "belongSpace"
  }, loading ? /*#__PURE__*/React.createElement(_Cascader, null) : /*#__PURE__*/React.createElement(SelectSpace, null));
};
export default SelectSpaceFormItem;